(function () {
  'use strict';

  function updateResponsiveBeratung() {
    const screenWidth = window.innerWidth;
    const headline = document.querySelector('.Pdp-Beratung-Headline');
    const subtext = document.querySelector('.Pdp-Beratung-Subtext');

    if (!headline || !subtext) return;

    // MOBILE
    if (screenWidth >= 320 && screenWidth <= 767) {
      headline.classList.remove('text-headline-m-desktop');
      headline.classList.add('text-headline-m-mobile');

      subtext.classList.remove('text-body-xl');
      subtext.classList.remove('text-body-l');
      subtext.classList.add('text-body-s');
    }

    // TABLET
    if (screenWidth >= 768 && screenWidth <= 1023) {
      headline.classList.remove('text-headline-m-desktop');
      headline.classList.add('text-headline-m-mobile');

      subtext.classList.remove('text-body-xl');
      subtext.classList.remove('text-body-s');
      subtext.classList.add('text-body-l');
    }

    // LAPTOP
    if (screenWidth >= 1024 && screenWidth <= 1439) {
      headline.classList.remove('text-headline-m-mobile');
      headline.classList.add('text-headline-m-desktop');

      subtext.classList.remove('text-body-l');
      subtext.classList.remove('text-body-s');
      subtext.classList.add('text-body-xl');
    }

    // DESKTOP
    if (screenWidth >= 1439) {
      headline.classList.remove('text-headline-m-mobile');
      headline.classList.add('text-headline-m-desktop');

      subtext.classList.remove('text-body-l');
      subtext.classList.remove('text-body-s');
      subtext.classList.add('text-body-xl');
    }
  }

  updateResponsiveBeratung();
  window.addEventListener('resize', updateResponsiveBeratung);
})();
